export default __webpack_public_path__ + "static/test_tom_3_2-2fe2886b23d0f8b81ea1344a104506a2.png";